<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Master Budget Addition Form
                <div class="card-header-actions">
                    <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
                    <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Master Budget No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomor" readonly :state="!$v.model.pjxhdrkey.$error"></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="lkuBudgetShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col md="4">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Master Budget Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date"  disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col md="9">
                            <b-input-group >
                                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                <b-form-input v-model="model.uraian"  placeholder="Budget Description" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.sales" disabled class="mt-1">Budget Sales/Project</b-form-checkbox>
                        </b-col>
                    </b-row>    

                    <b-row v-if="(model.sales=='1')">
                        <b-col md="7">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.custinfo" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer Order No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.cust_po" placeholder="Customer Order No." readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    <!-- <b-row>
                        <b-col md="4">
                            <b-input-group>
                                <b-input-group-prepend><label>Jumlah Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.jmlproduksi" type="number" disabled ></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">kali</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col md="7">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Nomor Produk/Eps.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomorproduksi" readonly placeholder="comma separated" ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >   -->
                    <b-input-group>
                        <b-input-group-prepend><label>Jumlah Produksi</label></b-input-group-prepend>
                        <b-form-input v-model="model.jmlproduksi" type="number" disabled ></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">kali</span></b-input-group-prepend>
                        <b-input-group-prepend><label> &nbsp;&nbsp;No. Produk/Eps.</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomorproduksi" readonly placeholder="comma separated" style="width:60% !important;" ></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col md="7">
                            <b-input-group >
                                    <b-input-group-prepend><label >Periode Produksi</label></b-input-group-prepend>
                                    <b-form-input v-model="model.startdate" type="date" disabled></b-form-input>
                                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                                    <b-form-input v-model="model.finishdate" type="date" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group>
                                <b-input-group-prepend><label>Lokasi Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.lokasi" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    

                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
              </b-row>
            <hr>
              <b-row>
                <b-col lg="8">
                    <b-row >
                        <b-col cols="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Additional Budget#</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomoradd" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.addtanggal" type="date" :state="!$v.model.addtanggal.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-input-group>
                        <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                        <b-form-input v-model="model.remark" :state="!$v.model.remark.$error"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="4">
                            <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.insertepisode"  class="mt-1">Insert New Episode to Master Budget</b-form-checkbox>
                </b-col>
              </b-row>

            <div class="report-wraper" >
                <table style="width: 100%;" v-show="(showFormDetail == false)">
                    <thead>
                        <tr>
                            <th style="width:15px;text-align:center;padding:0;" rowspan="2">No.</th>
                            <th colspan="7" style="text-align:center">MASTER BUDGET</th>
                            <!-- <th width="120px" style="text-align:center">REQUESTED</th> -->
                            <th style="text-align:center">ADDITIONAL BUDGET</th>
                        </tr>
                        <tr>
                            <th style="min-width:300px;">Description</th>
                            <th style="text-align:center;max-width:40px;padding:0;" >Unit</th>
                            <th style="text-align:center;max-width:40px;padding:0;" >QTY</th>
                            <th style="text-align:center;max-width:50px;padding:0;">Repetition</th>
                            <th style="text-align:right;max-width:120px;" >Unit Price</th>
                            <th style="text-align:right;max-width:120px;">Amount </th>
                            <th >Remark </th>
                            <!-- <th style="text-align:center" width="120px">(IN USED)</th> -->
                            <!-- <th style="text-align:center;" width="80px">Quantity</th>
                            <th style="text-align:center;" width="100px">Repetition</th> -->
                            <th style="text-align:right;max-width:120px !important;">Amount </th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in budgetLines" :key="row.pjxbudgkey">
                            <!-- <td>{{irow.seqNo}}</td> -->
                            <td>{{idx+1}}</td>
                            <td>{{row.jccostname}} &nbsp; &nbsp; {{row.uraian}}</td>
                            <td style="text-align:center;max-width:40px;padding:0;">{{row.unitsize}}</td>
                            <td style="text-align:center;max-width:40px;padding:0;">{{row.quantity}}</td>
                            <td style="text-align:center">{{row.repetit_qty}} {{row.repetit_nm}}</td>
                            <td style="text-align:right">{{row.unitprice |numFormat}}</td>
                            <td style="text-align:right;max-width:120px !important;">{{row.budgetamt |numFormat}}</td>
                            <td>{{row.remark}}</td>
                            <!-- <td style="text-align:right">{{row.toalreq |numFormat}}</td> -->
                            <!-- <td>
                                <b-form-input v-model="row.addquantity"  type="number" :min="0" @change="calcAmount(row)"></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-model="row.addrepetit_qty"  type="number" :min="0" @change="calcAmount(row)"></b-form-input>
                            </td> -->
                            <td style="text-align:right;max-width:120px !important;">
                                <my-number v-if="(saveEnabled==true)" v-model="row.addbudgetamt"  class="form-control text-right"  style="border:none; font-size: 0.8rem !important;" :precision="2" :minus="true" @change="calcPrice()"></my-number>
                                <span v-else>{{row.addbudgetamt |numFormat}}</span>                                
                            </td>
                            <td style="text-align:center;max-width:40px !important;">
                                <div class="text-center" v-if="!(row.pjxbudgkey)">
                                <a href="javascript:void(0)" @click="editOrdLines(row,idx)">
                                    <i class="fa fa-pencil"></i>
                                </a>
                                  |
                                <a href="javascript:void(0)" class="text-danger" @click="delOrdLines(idx)">
                                    <i class="fa fa-trash"></i>
                                </a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="subtotal"></td>
                            <td class="subtotal">                         
                                <b-button size="sm" variant="primary" class="m-1" v-if="saveEnabled" :disabled="!(model.pjxhdrkey)" @click.stop="addDetail" >Add Budget Detail</b-button>                          
                            </td>
                            <td class="subtotal" colspan="4" style="text-align:right">Total Master Budget</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlmstr|numFormat}}</td>
                            <!-- <td class="subtotal" style="text-align:right"> Budget Used</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlused|numFormat}}</td>  
                            <td class="subtotal" colspan="2" style="text-align:right">Total Additional Budget</td> -->
                            <td class="subtotal" style="text-align:right">Total Additional Budget</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttladd|numFormat('0,0.00')}}</td>
                        </tr>
                    </tbody>
                </table>           

                <b-row class="justify-content-center" v-if="showFormDetail">
                    <b-col cols="12">
                        <b-card class="row-details-form" title="Add Detail Budget">
                                <b-row h-align="center">
                                    <b-col lg="6">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Costing Item</label></b-input-group-prepend>
                                            <b-form-input readonly v-model="ordLinesObj.iteminfo" :state="!$v.ordLinesObj.jccostkey.$error"></b-form-input>
                                            <b-input-group-append>
                                            <b-btn text="Button" @click="lkuItemShow=true" id="glAccount">
                                                <i class="fa fa-search"></i>
                                            </b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <b-row>
                                            <b-col lg="6">
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                                    <b-form-input v-model="ordLinesObj.addquantity" @change="calcPrice()" type="number" :state="!$v.ordLinesObj.addquantity.$error"></b-form-input>
                                                    <b-form-input v-model="ordLinesObj.unitsize" class="ml-1" readonly ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col lg="6">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Unit price</label></b-input-group-prepend>
                                                    <b-input-group-prepend><span class="input-group-text">{{uanguser}}</span></b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="ordLinesObj.unitprice" :precision="2" :minus="true" :state="!$v.ordLinesObj.unitprice.$error"></my-number>
                                                </b-input-group>
                                            </b-col>
                                        </b-row >                      
                                        <b-row>
                                            <b-col lg="6">
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Repetition</label></b-input-group-prepend>
                                                    <b-form-input v-model="ordLinesObj.addrepetit_qty" @change="calcPrice()" type="number" ></b-form-input>
                                                    <b-form-input v-model="ordLinesObj.repetit_nm" class="ml-1" ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col lg="6">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Amount</label></b-input-group-prepend>
                                                    <b-input-group-prepend>
                                                    <span class="input-group-text">{{uanguser}}</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="ordLinesObj.addbudgetamt" :precision="2" :minus="true" disabled></my-number>
                                                </b-input-group>
                                            </b-col>
                                        </b-row >                      
                                    </b-col>
                                    <b-col lg="6">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                                            <b-form-textarea :rows="5" :max-rows="5" v-model="ordLinesObj.uraian" ></b-form-textarea>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                        <b-row class="justify-content-center mt-1">
                            <b-button v-if="saveEnabled" class="btn btn-success mr-1" @click.stop="saveOrdLines">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click.stop="cancelOrdLines">Cancel</b-button>
                        </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </div>                  

            <b-row class="justify-content-center mt-2" v-show="(showFormDetail == false)">
                <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
                <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </b-card>
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Master Budget" :centered="true">
            <lku-budgetproduksi @click="onSelectLkuBudget"></lku-budgetproduksi>
        </b-modal>        
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Budget Item" :centered="true">
            <lku-item @click="onSelectLkuItem" ></lku-item>
        </b-modal>        
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    </div>    
</template>
<style lang="scss">

    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 90px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import lkuBudgetproduksi from "../lookup/lkuBudgetproduksi_all";
import lkuItem from "../lookup/lkuItembudget";
import budgetadditional from "../../apis/budgetadditional";
// import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading,myNumber, vDim, lkuBudgetproduksi,lkuItem},
  mixins: [validationMixin],
  validations: {
        model: {
            pjxhdrkey: {required},
            remark: { required },
            addtanggal: { required }
        },
        ordLinesObj: {
            jccostkey: { required },
            addquantity: { numeric, required },
            unitprice: { numeric, required },
            addbudgetamt: { numeric, required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        isLoading: false,
        lkuItemShow:false,
        lkuBudgetShow:false,
        updateDimHdr:false,
        uanguser: this.$store.state.user.matauang,
        budgetLines:[], arrProduksi:[],
        showFormDetail:false,
        model: {
            pjxhdrkey: '',
            remark: '',
            addtanggal: '',
            insertepisode:0
        },
        ordLinesObj: {
            jccostkey: '',
            addquantity: 0,
            unitprice: 0,
            addbudgetamt: 0,linetype:1
        },

    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidOrdLines() {
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    unitprice(){
        return this.ordLinesObj.unitprice;
    },    
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcPrice();
        }, 100);
    },    
  },  
  created: async function(){
        if (this.$route.params.addhdkey)  {
          toastr.info('Loading Budget Detail, please wait')
          try {
            const data = await budgetadditional.detail(this.$route.params);  
            const row = data[0];
            this.saveEnabled=(row.send2wf === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            row.addtanggal = row.addtanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';

            for (var key in row) {
                this.model[key] = row[key];
            }
            this.dimension.forEach((dim) => {
                if (this.model[dim.value]) {
                    this.model[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
                }
            });
            
            this.budgetLines = data[1];
            // this.budgetLines.forEach((line,idx) => {
            //     this.budgetLines[idx].budgetrata2= line.budgetamt/this.model.jmlproduksi;
            // });
            this.calcTotalDtlBudget();
            toastr.clear;
            this.updateDimHdr = !this.updateDimHdr;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.addtanggal  = moment().format('YYYY-MM-DD');
        }
  },
  methods: {
    addDetail: function() {
        this.ordLinesObj = {linetype:1,jccostkey:'', uraian:'', quantity:0, unitzise:'', unitprice:0, addbudgetamt:0};
        this.showFormDetail=true;
        this.editLine=false;
    },
    editOrdLines: function (row,index) {
        if (index > -1) {
            this.budgetLines.splice(index, 1);
        }
        // this.calcTotalDtlBudget();
        const obj={};
        this.ordLinesB4={};        
        for (var key in row) {
            obj[key] = row[key];
            this.ordLinesB4[key] = row[key];
        }
        this.ordLinesObj=obj;
        this.editLine=true;
        this.showFormDetail=true;
    },
    delOrdLines: function (index) {
        if (index > -1) {
        this.budgetLines.splice(index, 1);
        }
        this.calcTotalDtlBudget();
    },
    saveOrdLines: function () {
        // this.calcPrice();
        if (this.invalidOrdLines) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            console.log('validation : ', this.$v.ordLinesObj);
            console.log('ordLinesObj obj : ',this.ordLinesObj);
       } else {
            try {
                this.budgetLines.push(this.ordLinesObj);
                this.calcTotalDtlBudget();
                this.showFormDetail=false;

            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    cancelOrdLines: function() {
        if (this.editLine==true) {
                this.budgetLines.push(this.ordLinesB4);
                this.calcTotalDtlBudget();
        }
        this.showFormDetail=false;
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;
        this.saveEnabled=false;
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;
            this.isLoading=false;
        } else {
            try {
                    const row = {};
                    row.addhdkey = this.model.addhdkey || '';
                    row.nomoradd = this.model.nomoradd || '';
                    row.addtanggal= this.model.addtanggal ? moment(this.model.addtanggal).format('YYYY-MM-DD') : undefined;
                    row.pjxhdrkey = this.model.pjxhdrkey || '';
                    row.nomor = this.model.nomor || '';
                    row.remark = this.model.remark || '';
                    row.insertepisode = this.model.insertepisode || 0;
                    row.addepisode = '';
                    if (this.model.insertepisode) {
                        this.arrProduksi= this.model.nomorproduksi.split(",");
                        const addepisode= parseInt(this.arrProduksi[this.arrProduksi.length-1])+1;
                        row.addepisode = addepisode;
                    }
                    let seqNo = 1;
                    row.lines=[];
                    this.budgetLines.forEach((item,idx) => {
                        seqNo += 1;
                        if (item.addbudgetamt) {
                        // if (((item.addquantity) && (item.addquantity!=0)) || ((item.addrepetit_qty) && (item.addrepetit_qty!=0))) {
                            this.budgetLines[idx].seqNo = seqNo;
                            row.lines.push(item);       
                        }
                    });
                    if (this.model.ttladd) {
                        // await budgetadditional.save(row);
                        // toastr.success("Complete successfully", "Save Budget");
                        const hasil= await budgetadditional.save(row);
                        this.isLoading=false;
                        toastr.success(`Success, Trx.Number ${hasil.nomoradd}`, "Save Budget",10000);
                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Budget Detail', 'ERROR MESSAGE');
                        this.saveEnabled=true;
                        this.isLoading=false;
                    }
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    onSelectLkuBudget: async function (_selected) {
        try {
            toastr.info('Loading Master Budget Detail, please wait')
            this.lkuBudgetShow=false;
            const data = await budgetadditional.mstrbudget({pjxhdrkey:_selected.pjxhdrkey});  
            const row = data[1][0];
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.dimension.forEach((dim) => {
                if (row[dim.value]) {
                    this.model[`${dim.value}Info`] = row[dim.value] + ' | '+ row[`${dim.value}Txt`];
                }
            });
            this.updateDimHdr=!this.updateDimHdr;
            this.budgetLines = data[0];
            // this.budgetLines.forEach((line,idx) => {
            //     this.budgetLines[idx].budgetrata2=line.budgetamt/this.model.jmlproduksi;
            //     this.budgetLines[idx].addquantity=0;
            //     this.budgetLines[idx].addrepetit_qty='';
            // });

            this.calcTotalDtlBudget();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }

    },
    onSelectLkuItem(_selected) {
        if (_selected.judul!='Y') {
        this.ordLinesObj.iteminfo = _selected.jccostcode.trim() + ' | ' + _selected.jccostname.trim();
        this.ordLinesObj.jccostkey = _selected.jccostkey;
        this.ordLinesObj.jccostcode = _selected.jccostcode;
        this.ordLinesObj.jccostname = _selected.jccostname;
        this.ordLinesObj.judul = _selected.judul;
        this.ordLinesObj.level_ = _selected.level_;
        this.lkuItemShow=false;
        } else {
            toastr.error('Judul/Header tidak boleh dipilih sbg detail budget', 'ERROR MESSAGE');
        }
    },    
    calcAmount : function (budgetLine) {
        budgetLine.addbudgetamt = parseFloat(budgetLine.addquantity) * parseFloat(budgetLine.unitprice) * parseFloat(budgetLine.addrepetit_qty || 1);
        this.calcTotalDtlBudget();
        this.$forceUpdate();
    },
    calcPrice : function () {
        this.ordLinesObj.addbudgetamt = parseFloat(this.ordLinesObj.addquantity) * parseFloat(this.ordLinesObj.unitprice) * parseFloat(this.ordLinesObj.addrepetit_qty || 1);
        setTimeout(() => {
            this.calcTotalDtlBudget();
        }, 200);
    },
    calcTotalDtlBudget: function () {
        let ttlamtdue = 0;
        let ttlamtadd = 0;
        let ttlamtused = 0;
        this.budgetLines.forEach( function (trx) {
                ttlamtdue += (trx.budgetamt || 0);
                ttlamtadd += (trx.addbudgetamt || 0);
                ttlamtused += (trx.totalreq || 0);
        });
        this.model.ttlmstr = ttlamtdue;
        this.model.ttladd = ttlamtadd;
        this.model.ttlused = ttlamtused;
    },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'budget.internbudgetfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        //   router.push({name:"budget.internbudget"});
          router.push("home");
      }
    }
  }
};
</script>
